import { render, staticRenderFns } from "./WrappedText.vue?vue&type=template&id=23a5c9ec&"
import script from "./WrappedText.vue?vue&type=script&lang=js&"
export * from "./WrappedText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports